var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1978",
    "data-name": "Group 1978",
    transform: "translate(0.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3180",
    "data-name": "Rectangle 3180",
    width: 28,
    height: 28,
    rx: 5,
    transform: "translate(-0.4 0)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-save-2209758",
    transform: "translate(6.38 6.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8987",
    "data-name": "Path 8987",
    d: "M142.923,360.66v3.373a.771.771,0,0,1-.024.187.724.724,0,0,1-.705.581H128.407a.722.722,0,0,1-.715-.643.566.566,0,0,1-.01-.13v-3.373a.72.72,0,0,1,1.44,0v2.7h12.366v-2.7a.719.719,0,0,1,1.228-.509.761.761,0,0,1,.206.514Z",
    transform: "translate(-127.683 -349.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8988",
    "data-name": "Path 8988",
    d: "M230.446,65.794l-3.537,3.537c0,.01-.014.014-.019.019a.833.833,0,0,1-.465.235c-.014,0-.029,0-.043,0a.52.52,0,0,1-.086,0l-.082,0c-.014,0-.029,0-.043,0a.818.818,0,0,1-.465-.235l-.019-.019-3.537-3.537a.841.841,0,0,1,1.19-1.19l2.126,2.126V58.942a.844.844,0,0,1,.84-.84.858.858,0,0,1,.595.245.83.83,0,0,1,.245.595V66.73L229.27,64.6a.846.846,0,0,1,1.19,0,.859.859,0,0,1-.014,1.19Z",
    transform: "translate(-218.675 -58.102)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload1);
export default __webpack_public_path__ + "static/media/download1.2bf92c7ac3fa00ee9245490624da9725.svg";
export { ForwardRef as ReactComponent };